import { RotateCcw } from "lucide-react";
import { defaultCrop, normalizeCrop } from "../lib/crop";

export default function CropControls({ crop, onChange, compact = false }) {
  const value = normalizeCrop(crop);
  const update = (key, next) => onChange({ ...value, [key]: Number(next) });

  return (
    <fieldset className={compact ? "crop-controls is-compact" : "crop-controls"}>
      <legend>Crop and framing</legend>
      <label>Horizontal focus <input type="range" min="0" max="100" step="1" value={value.x} onChange={(event) => update("x", event.target.value)} /></label>
      <label>Vertical focus <input type="range" min="0" max="100" step="1" value={value.y} onChange={(event) => update("y", event.target.value)} /></label>
      <label>Zoom <input type="range" min="1" max="3" step="0.05" value={value.zoom} onChange={(event) => update("zoom", event.target.value)} /></label>
      <button className="text-link" type="button" onClick={() => onChange({ ...defaultCrop })}><RotateCcw aria-hidden="true" /> Reset crop</button>
    </fieldset>
  );
}
